import { render, staticRenderFns } from "./TransPolish.vue?vue&type=template&id=061b687c&scoped=true&"
import script from "./TransPolish.vue?vue&type=script&lang=js&"
export * from "./TransPolish.vue?vue&type=script&lang=js&"
import style0 from "./TransPolish.vue?vue&type=style&index=0&id=061b687c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b687c",
  null
  
)

export default component.exports